import { Component, OnInit } from '@angular/core';
import { PageComponent, PageService, Shell, Transfer, PagedArray } from 'common';
import { ActivatedRoute, Router } from '@angular/router';
import { OpenPosition } from 'models/OpenPosition';
import { CareersApi } from 'api';

@Component({
  selector: 'tyt-jobs-page',
  templateUrl: './jobs-page.component.html',
  styleUrls: ['./jobs-page.component.scss']
})
export class JobsPageComponent extends PageComponent implements OnInit {

  constructor(
    pageService: PageService,
    private route: ActivatedRoute,
    private careersApi: CareersApi
  ) {
    super(pageService);
  }

  @Transfer()
  jobs : PagedArray<OpenPosition>;
  currentJob : OpenPosition;

  ready: boolean = false;

  async init() {
    this.pageTitle = 'Careers';
    
    this.subscribe(this.route.params, async params => {
      if (params.id) {
        this.currentJob = await this.careersApi.get(params.id).toPromise();
      } else {
        this.currentJob = null;
        this.jobs = await this.careersApi.all().toPromise();
      }
      this.ready = true;
    });

  }


}
